module.exports = "<h2 id=layer-order>Layer order</h2> <p>Let&#39;s talk about ordering our layers for styling. <code>order</code> is a parameter that sets the drawing order of the draw style. It is meant to be used in cases where layers cover the same pixel space, meaning that one layer will take precedence over another when they get drawn. You can use the <code>order</code> parameter to specify which higher-ordered layers should be drawn over lower-ordered layers. Try the exercise below:</p> <p>[section] { &quot;type&quot;: &quot;tangram&quot;, &quot;src&quot;: &quot;styling2.yaml&quot;, &quot;lines&quot;: &quot;15,20&quot; } [section]</p>";


/*****************
 ** WEBPACK FOOTER
 ** ./Assets/markdown/styling2.md
 ** module id = 688
 ** module chunks = 1
 **/